import { useMemo } from "react";

import { useQueryClient } from "@tanstack/react-query";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { createQuotaQueryClient } from "../queries/client/factory";

/**
 * React hook wrapper around quotaQueryClient.
 */
export const useQuotaQueryClient = () => {
    const queryClient = useQueryClient();

    return useMemo(() => createQuotaQueryClient({ queryClient, salesSettingsHelper }), [queryClient]);
};
